import {
  ErrorBoundary as RollbarErrorBoundary,
  ErrorBoundaryProps as RollbarErrorBoundaryProps,
} from '@rollbar/react';
import { ComponentType, FC, memo } from 'react';

type FallbackProps = {
  error: Error | null;
};

type Fallback = ComponentType<FallbackProps>;
export type ErrorBoundaryProps = {
  fallback: Fallback;
  shouldPropagate?: boolean | ((error: Error | null) => boolean);
} & Omit<RollbarErrorBoundaryProps, 'fallbackUI'>;

export const ErrorBoundary: FC<ErrorBoundaryProps> = memo(
  ({ children, fallback: UI, shouldPropagate = false, ...rest }) => {
    return (
      <RollbarErrorBoundary
        fallbackUI={({ error }) => {
          const shouldThrowError =
            typeof shouldPropagate === 'function'
              ? shouldPropagate(error) === true
              : shouldPropagate === true;

          if (shouldThrowError) {
            throw error;
          }

          return <UI error={error} />;
        }}
        {...rest}
      >
        {children}
      </RollbarErrorBoundary>
    );
  }
);
ErrorBoundary.displayName = 'ErrorBoundary';
